module.exports = __webpack_public_path__ + "static/Williams-18fdd1ee0f752b9e4a31c496d8f26294.jpg";